module.exports = __webpack_public_path__ + "img/logo.bd35500e.png";